import React from 'react';
import PropTypes from 'prop-types';
import { v1 as uuidv1 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next'

import Yup from '../../../../i18n/yup';
import ImageUploader from '../ImageUploader';
import fetch from '../../../../utils/fetcher';
import useStyles from './styles';
import ErrorMessage from '../ErrorMessage';

const youtubeUrl = `${process.env.REACT_APP_MEDIA_API_URL}/image`;
const imgValidationSchema = Yup.mixed().isValidImage();

const ImageInputComponent = ({
  uploading,
  setUploading,
  setFieldValue,
  setFieldError,
  campaignId,
  id,
}) => {
  const { t } = useTranslation(['translation']);
  const classes = useStyles();

  const uploadImage = async (_id, file) => {
    try {
      await imgValidationSchema.validate(file);
    } catch (error) {
      setFieldError(`COMMON.${error.message}`);
      throw error
    }
    setUploading(true);
    const campaign = campaignId || uuidv1().slice(0, 7);
    const formData = new FormData();
    formData.append('image', file);
    formData.append('campaign', campaign);
    let data;
    try {
      data = await fetch(youtubeUrl, {
        method: 'POST',
        body: formData,
      }).then(res => res.json());
    } catch (error) {
      setFieldError(`COMMON.${error.errorCode}`);
      throw error;
    } finally {
      setUploading(false);
    }
    if (data.status === 'done') {
      setFieldValue(data.videoId);
    } else {
      const errorMessage = 'CAMPAIGN.IMAGE_UPLOADER.IMAGE_UPLOAD_ERROR';
      setFieldError(errorMessage);
      throw new Error(errorMessage);
    }
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <ImageUploader
          id="imageForUpload"
          setFieldValue={uploadImage}
          title={t('COMMON.IMAGE_UPLOADER.TITLE')}
          text={t('COMMON.IMAGE_UPLOADER.TEXT')}
          hint={t('COMMON.IMAGE_UPLOADER.HINT')}
        />
        {uploading && (
          <div className={classes.uploadingIconWrapper}>
            <FontAwesomeIcon icon={faSpinner} pulse />
          </div>
        )}
      </div>
      <ErrorMessage id={id} />
    </div>
  );
};


ImageInputComponent.defaultProps = {
  campaignId: null,
};

ImageInputComponent.propTypes = {
  uploading: PropTypes.bool.isRequired,
  setUploading: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
  campaignId: PropTypes.string,
  id: PropTypes.string.isRequired,
};

export default ImageInputComponent;
